import { Component } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: false,
})
export class AppComponent {
  title = 'portal-web';
  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
  ) {
    this.matIconRegistry.addSvgIcon(
      `status_page`,
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/status_page.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      `no-source-selected`,
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/no_source_selected.svg'),
    );
    this.matIconRegistry.addSvgIcon(`nifi`, this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/nifi_icon.svg'));
  }
}
